export const websiteEyebrowText = "text-sm font-semibold uppercase tracking-[0.28em]";

export const websiteBodyText = "text-lg leading-relaxed md:text-xl";

export const websiteCardTitleText = "text-2xl font-semibold leading-tight md:text-3xl";

export const websiteSectionTitleText = "text-3xl font-bold leading-tight md:text-5xl lg:text-[3.75rem]";

export const websiteHeroTitleText = "text-[clamp(2.8rem,6.4vw,5rem)] font-bold leading-[1.04] tracking-tight md:text-6xl lg:text-[4rem]";